import debug from 'debug';

export default (namespace: string) => debug(`Maximus::${namespace}`);
